var _defs, _path, _g, _circle, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: ProximaNova-Bold, 'Proxima Nova';\n        font-size: 55px;\n        letter-spacing: 0em;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fff;\n        font-weight: 700;\n      }\n\n      .cls-3 {\n        fill: #747474;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        font-family: Poppins-Bold, Poppins;\n        font-size: 32.4px;\n        letter-spacing: 0em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.2,15.5h55c4.6,1.8,6.1,5.3,6.1,10.2-.2,18.1,0,36.2,0,54.3v3.3h3.1c8.6,0,17.1-.2,25.7,0,8.5.2,14.4,4.6,18,12.2.7,1.5,1.1,3.2,1.7,4.9v146.6c0,.2-.3.2-.3.4-3.3,11.5-10.1,16.7-22.1,16.7h-8.4v8c-.2,4.9-3.4,8.2-7.9,8.2s-7.6-3.4-7.7-8.3v-7.7h-26.9v7.8c0,4.9-3.3,8.3-7.8,8.2-4.5,0-7.7-3.4-7.7-8.3v-7.7h-25.2v8.7c-.2,4-3.2,7-7.1,7.3-4.6.3-8.2-3-8.3-7.9v-7.9h-89.3v8.4c0,3.3-1.7,5.8-4.9,7.1-5,2.1-10.3-1.4-10.6-7.1-.2-2.8,0-5.6,0-8.7-4.5,0-8.6.2-12.6,0-6.1-.3-11.2-3-14.6-8-1.8-2.7-2.8-6-4.1-9.1v-91.7c0-.2.2-.2.3-.4,3.2-11.5,10-16.7,22-16.7h36.1v-34.2c0-6.5,2.9-9.3,9.3-9.3h37.1c1.4,0,2.3-.4,3.1-1.7,4-6.5,9.9-9.7,17.5-9.8h24.7V25.2c0-4.9,1.7-8.1,6.3-9.8h-.5ZM218.9,98.9v149.5h67.3V98.9h-67.3ZM114.1,153.8v94.7h57.8v-94.7s-57.8,0-57.8,0ZM203,98.8h-8.8c-5.6,0-6.8,1.2-6.8,6.8v138.3c.2,2.5,1.7,4.4,4.2,4.5,3.8.2,7.6,0,11.5,0V98.8h0ZM302,248.5h8.3c5.4,0,6.8-1.4,6.8-6.8V103c-.3-2.2-1.6-3.9-3.7-4.1-3.7-.3-7.5,0-11.3,0v149.6h0ZM232.7,31.1v51.9h35.8V31.1h-35.8ZM98.1,248.7v-95h-9.3c-4.9,0-6.4,1.4-6.4,6.3v83.3c0,3.4,1.7,5.2,4.9,5.3h10.8ZM141.1,110.3v27.7h30.5v-27.7h-30.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.2,320.8h-12.7v6.9h11.2v6.4h-11.2v7.5h12.7v6.7h-21v-34.3h21v6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.4,320.8c3.6,0,6.3,1.4,8,3.4v-3.1h8.4v40.3h-8.4v-16.4c-1.8,2.1-4.4,3.8-8.1,3.8-6.7,0-12.4-5.6-12.4-13.9s5.7-14,12.5-14h0ZM133.4,328c-2.8,0-6,2.1-6,6.7s3.2,6.7,6,6.7,6-2.2,6-6.7-3.1-6.7-6-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.7,348.4h-8.4v-3.7c-1.7,2.3-4.6,4-8.3,4-6.3,0-10.6-4.3-10.6-11.6v-15.9h8.3v14.8c0,3.7,2.1,5.8,5.2,5.8s5.3-2.1,5.3-5.8v-14.8h8.4v27.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.9,313.8c0-2.5,2-4.5,5-4.5s4.9,2,4.9,4.5-2,4.5-4.9,4.5-5-2-5-4.5ZM186.7,321.1h8.4v27.3h-8.4v-27.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.9,320.7c6.7,0,12,5.4,12,14s-5.3,14.1-12,14.1-6.9-1.9-8.4-4.2v16.8h-8.4v-40.3h8.4v3.9c1.5-2.4,4.4-4.3,8.4-4.3ZM215.4,328c-3.1,0-6,2.4-6,6.7s2.8,6.7,6,6.7,6-2.4,6-6.8-2.8-6.7-6-6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.7,320.7c4.1,0,6.9,1.9,8.4,4.3v-3.9h8.4v27.3h-8.4v-3.9c-1.5,2.4-4.4,4.2-8.5,4.2-6.6,0-12-5.5-12-14.1s5.3-14,12-14h0ZM247.1,328c-3.1,0-6,2.3-6,6.7s2.8,6.8,6,6.8,6-2.4,6-6.7-2.8-6.7-6-6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M275.8,321.1v30.8c0,7.1-4,9.5-9.6,9.5h-3.3v-7.1h2c1.9,0,2.5-.7,2.5-2.3v-30.9h8.4ZM266.6,313.8c0-2.5,2-4.5,5-4.5s4.9,2,4.9,4.5-2,4.5-4.9,4.5-5-2-5-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294,348.8c-8,0-13.8-5.4-13.8-14s5.7-14,13.8-14,13.6,5.3,13.6,13.6,0,1.6-.1,2.4h-18.9c.3,3.6,2.5,5.2,5.2,5.2s3.7-1.2,4.3-2.6h8.9c-1.3,5.3-6.2,9.4-12.9,9.4h-.1ZM288.5,332.1h10.5c0-3-2.3-4.7-5.1-4.7s-4.8,1.7-5.3,4.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34,379.3c3.6,0,6.7,1.7,8.4,4.2v-12.7h8.4v36.2h-8.4v-3.9c-1.5,2.5-4.4,4.3-8.4,4.3-6.7,0-12-5.5-12-14.1s5.3-14,12-14ZM36.4,386.6c-3.1,0-6,2.3-6,6.7s2.8,6.8,6,6.8,6-2.4,6-6.7-2.8-6.7-6-6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.2,407.4c-8,0-14.1-5.4-14.1-14s6.2-14,14.2-14,14.2,5.4,14.2,14-6.3,14-14.3,14ZM69.2,400.2c3,0,5.8-2.2,5.8-6.8s-2.7-6.8-5.7-6.8-5.7,2.1-5.7,6.8,2.5,6.8,5.6,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.9,379.3c6.8,0,11.7,3.8,13.1,10.3h-8.9c-.7-1.9-2.1-3.1-4.3-3.1s-5,2.3-5,6.9,2.1,6.9,5,6.9,3.6-1.1,4.3-3.1h8.9c-1.4,6.3-6.3,10.3-13.1,10.3s-13.7-5.4-13.7-14,5.7-14,13.7-14v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.4,407h-8.4v-3.7c-1.7,2.3-4.6,4-8.3,4-6.3,0-10.6-4.3-10.6-11.6v-15.9h8.3v14.8c0,3.7,2.1,5.8,5.2,5.8s5.3-2.1,5.3-5.8v-14.8h8.4v27.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188,392.2c0-3.6-2.1-5.5-5.2-5.5s-5.2,2-5.2,5.5v14.8h-8.3v-14.8c0-3.6-2.1-5.5-5.2-5.5s-5.2,2-5.2,5.5v14.8h-8.4v-27.3h8.4v3.4c1.6-2.2,4.4-3.7,8-3.7s7.4,1.8,9.3,5.1c1.8-2.9,5.2-5.1,9.2-5.1,6.7,0,11.1,4.3,11.1,11.6v15.9h-8.3v-14.8h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.3,407.4c-8,0-13.8-5.4-13.8-14s5.7-14,13.8-14,13.6,5.3,13.6,13.6,0,1.6-.1,2.4h-18.9c.3,3.6,2.5,5.2,5.2,5.2s3.7-1.2,4.3-2.6h8.9c-1.3,5.3-6.2,9.4-12.9,9.4h-.1ZM208.8,390.7h10.5c0-3-2.3-4.7-5.1-4.7s-4.8,1.7-5.3,4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.1,392.2c0-3.7-2.1-5.8-5.2-5.8s-5.2,2.1-5.2,5.8v14.8h-8.4v-27.3h8.4v3.6c1.7-2.3,4.6-3.9,8.3-3.9,6.3,0,10.5,4.3,10.5,11.6v15.9h-8.3v-14.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266.5,386.7h-3.3v-6.9h3.3v-6.6h8.4v6.6h5.5v6.9h-5.5v10.9c0,1.6.7,2.3,2.5,2.3h3v7.1h-4.3c-5.7,0-9.6-2.4-9.6-9.5v-10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M295.4,379.3c4.1,0,6.9,1.9,8.4,4.3v-3.9h8.4v27.3h-8.4v-3.9c-1.5,2.4-4.4,4.2-8.5,4.2-6.6,0-12-5.5-12-14.1s5.3-14,12-14h.1ZM297.8,386.6c-3.1,0-6,2.3-6,6.7s2.8,6.8,6,6.8,6-2.4,6-6.7-2.8-6.7-6-6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.6,379.3c3.6,0,6.7,1.7,8.4,4.2v-12.7h8.4v36.2h-8.4v-3.9c-1.5,2.5-4.4,4.3-8.4,4.3-6.7,0-12-5.5-12-14.1s5.3-14,12-14ZM331,386.6c-3.1,0-6,2.3-6,6.7s2.8,6.8,6,6.8,6-2.4,6-6.7-2.8-6.7-6-6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M363.8,407.4c-8,0-14.1-5.4-14.1-14s6.2-14,14.2-14,14.2,5.4,14.2,14-6.3,14-14.3,14h0ZM363.8,400.2c3,0,5.8-2.2,5.8-6.8s-2.7-6.8-5.7-6.8-5.7,2.1-5.7,6.8,2.5,6.8,5.6,6.8h0Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 252.6,
    cy: 174.7,
    r: 53.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(202.5 193.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(262 193.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "kg"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleta);
export default __webpack_public_path__ + "static/media/maleta.560265bfaa0712bae940c6d5407fa93a.svg";
export { ForwardRef as ReactComponent };